export const PROTECTED_TECHNICAL_TERMS = {
  download: 'Download',
  upload: 'Upload',
  export: 'Export',
  import: 'Import',
  greenBean: 'Green Bean',
  roastedBulk: 'Roasted Bulk',
  finishedGood: 'Finished Good',
} as const;
